module.exports = __webpack_public_path__ + "media/images/icons/flags/SG-cdbe22b084c5f5b966f2a2ee5538bbd0.svg";